import { effect, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PaymentOptionService{

    private readonly PAYMENT_OPTION_KEY = 'selectedPaymentOption';
    private readonly _selected = signal<string>(this.loadInitialPaymentOption());
    public readonly selected = this._selected.asReadonly();

    constructor() {
        effect(() => {
            localStorage.setItem(this.PAYMENT_OPTION_KEY, this._selected())
        })
    }

    private loadInitialPaymentOption(): string{
        const savedOption = localStorage.getItem(this.PAYMENT_OPTION_KEY);
        return savedOption || '';
    }

    setSelected(type: string): void {
        const current = this._selected();
        if (current !== type)
            this._selected.set(type);
    }
}